import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import GridViewIcon from "@mui/icons-material/GridView";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import type { SvgIconComponent } from "@mui/icons-material";
import type { BadgeId } from "@/utils/arcade/progress";

const ICONS: Record<BadgeId, SvgIconComponent> = {
  "first-run": SportsEsportsIcon,
  boss: WhatshotIcon,
  "score-10k": EmojiEventsIcon,
  "streak-7": LocalFireDepartmentIcon,
  "all-six": GridViewIcon,
  "challenge-top10": CalendarMonthIcon,
};

export function BadgeIcon({ id, size = 18 }: { id: BadgeId; size?: number }) {
  const Icon = ICONS[id];
  return <Icon sx={{ fontSize: size }} />;
}

export default BadgeIcon;
